/* ============================================================
   ARRDEL — theme behaviors (ported from reference arrdel.js)
   Every module is guarded: it only runs if its markup exists.
   No storage APIs are used; all state is in-memory per page.
   No libraries, no jQuery.
   ============================================================ */
(function () {
  'use strict';

  var ROUTES = (window.ARRDEL && window.ARRDEL.routes) || {};
  var MONEY_FORMAT = (window.ARRDEL && window.ARRDEL.money_format) || '${{amount}}';
  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var noDecimals = parts[0];
    var withDecimals = parts.join('.');
    return MONEY_FORMAT
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, parts[1] === '00' ? noDecimals : withDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withDecimals);
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = '(' + count + ')';
    });
  }

  /* ---------- ticker: duplicate content for a seamless loop ---------- */
  (function () {
    var t = document.getElementById('ticker');
    if (t && !t.dataset.duplicated) {
      t.innerHTML += t.innerHTML;
      t.dataset.duplicated = 'true';
    }
  })();

  /* ---------- mobile menu ---------- */
  (function () {
    var menu = document.getElementById('mobileMenu');
    var toggle = document.getElementById('menuToggle');
    if (!menu || !toggle) return;
    function close() {
      menu.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    }
    toggle.addEventListener('click', function () {
      var open = menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    menu.addEventListener('click', function (e) {
      if (e.target.closest('.mobile-menu__close')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  })();

  /* ---------- search overlay + predictive search ---------- */
  (function () {
    var overlay = document.getElementById('searchOverlay');
    var openBtn = document.getElementById('searchOpen');
    if (!overlay || !openBtn) return;
    var input = overlay.querySelector('input[type="search"]');
    var results = overlay.querySelector('.predictive-results');
    var debounce;

    function open(e) {
      e.preventDefault();
      overlay.classList.add('is-open');
      openBtn.setAttribute('aria-expanded', 'true');
      if (input) input.focus();
    }
    function close() {
      overlay.classList.remove('is-open');
      openBtn.setAttribute('aria-expanded', 'false');
    }
    openBtn.addEventListener('click', open);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    var closeBtn = overlay.querySelector('.search-close');
    if (closeBtn) closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    if (!input || !results || !ROUTES.predictive_search_url) return;

    function render(products, query) {
      if (!products.length) {
        results.innerHTML = '';
        return;
      }
      var html = products.map(function (p) {
        var img = p.featured_image && p.featured_image.url
          ? '<img src="' + p.featured_image.url + '&width=120" alt="" width="56" height="70" loading="lazy">'
          : '<span></span>';
        var price = parseFloat(p.price_min != null ? p.price_min : p.price) || 0;
        return '<a href="' + p.url + '">' +
          img +
          '<span><span class="pr__house">' + (p.vendor || '').toUpperCase() + '</span><br>' +
          '<span class="pr__name">' + p.title + '</span></span>' +
          '<span class="pr__price">' + formatMoney(price * 100) + '</span>' +
          '</a>';
      }).join('');
      html += '<a class="pr__all" href="' + ROUTES.search_url + '?q=' + encodeURIComponent(query) + '">VIEW ALL RESULTS &rarr;</a>';
      results.innerHTML = html;
    }

    input.addEventListener('input', function () {
      clearTimeout(debounce);
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      debounce = setTimeout(function () {
        fetch(ROUTES.predictive_search_url + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            render((data.resources && data.resources.results.products) || [], q);
          })
          .catch(function () { results.innerHTML = ''; });
      }, 250);
    });
  })();

  /* ---------- wishlist hearts (visual only, in-memory) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.piece__hold');
    if (!b) return;
    e.preventDefault();
    b.classList.toggle('is-held');
    b.textContent = b.classList.contains('is-held') ? '♥' : '♡';
    b.setAttribute('aria-pressed', b.classList.contains('is-held'));
  });

  /* ---------- department index: static image stage, crossfade on hover ---------- */
  (function () {
    var list = document.getElementById('deptList');
    var stage = document.getElementById('deptStage');
    if (!list || !stage) return;
    var caption = document.getElementById('deptStageCaption');
    var imgs = stage.querySelectorAll('img');
    list.querySelectorAll('.dept').forEach(function (d, i) {
      function show () {
        imgs.forEach(function (im, j) { im.classList.toggle('show', j === i); });
        if (caption && d.dataset.caption) caption.textContent = d.dataset.caption;
      }
      d.addEventListener('mouseenter', show);
      d.addEventListener('focus', show);
    });
  })();

  /* ---------- film: fall back to ken-burns still if video fails ---------- */
  (function () {
    var v = document.getElementById('filmVideo');
    var f = document.getElementById('filmFallback');
    if (!v) return;
    function fallback() {
      if (v) v.remove();
      if (f) f.hidden = false;
      v = null;
    }
    v.addEventListener('error', fallback, true);
    var src = v.querySelector('source');
    if (src) src.addEventListener('error', fallback);
    setTimeout(function () { if (v && v.readyState < 2) fallback(); }, 4000);
  })();

  /* ---------- accordions (PDP + client care) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.acc__btn');
    if (!btn) return;
    var item = btn.closest('.acc__item');
    var acc = btn.closest('.accordion');
    if (acc && acc.dataset.single === 'true') {
      acc.querySelectorAll('.acc__item').forEach(function (i) {
        if (i !== item) {
          i.classList.remove('is-open');
          var b = i.querySelector('.acc__btn');
          if (b) b.setAttribute('aria-expanded', 'false');
        }
      });
    }
    item.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', item.classList.contains('is-open'));
  });

  /* ---------- collection: pills + sort via Section Rendering API ---------- */
  (function () {
    var root = document.getElementById('collectionRoot');
    if (!root) return;
    var sectionId = root.dataset.sectionId;
    var grid = root.querySelector('#collectionGrid');
    var sortSel = root.querySelector('#sortSelect');

    function vendorSort() {
      if (!grid) return;
      var cards = Array.prototype.slice.call(grid.querySelectorAll('.piece'));
      cards.sort(function (a, b) {
        return (a.dataset.vendor || '').localeCompare(b.dataset.vendor || '');
      });
      cards.forEach(function (c) { grid.appendChild(c); });
    }

    function load(url, push) {
      var fetchUrl = new URL(url, window.location.origin);
      fetchUrl.searchParams.set('section_id', sectionId);
      if (grid) grid.classList.add('is-loading');
      fetch(fetchUrl.toString())
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.getElementById('collectionRoot');
          if (fresh) {
            root.innerHTML = fresh.innerHTML;
            grid = root.querySelector('#collectionGrid');
            sortSel = root.querySelector('#sortSelect');
            if (sortSel && sortSel.value === 'vendor-asc') vendorSort();
          }
          if (push) history.pushState({ arrdel: true }, '', url);
        })
        .catch(function () { window.location.href = url; });
    }

    root.addEventListener('click', function (e) {
      var pill = e.target.closest('a.fpill');
      if (!pill) return;
      e.preventDefault();
      load(pill.href, true);
    });

    root.addEventListener('change', function (e) {
      /* storefront facets: serialize the facet form + keep the current sort */
      if (e.target.closest('#facetForm')) {
        var form = root.querySelector('#facetForm');
        var params = new URLSearchParams();
        form.querySelectorAll('input').forEach(function (inp) {
          if (inp.type === 'checkbox') {
            if (inp.checked) params.append(inp.name, inp.value);
          } else if (inp.value !== '') {
            params.append(inp.name, inp.value);
          }
        });
        var current = new URL(window.location.href);
        var sort = current.searchParams.get('sort_by');
        if (sort) params.set('sort_by', sort);
        var qs = params.toString();
        load(current.pathname + (qs ? '?' + qs : ''), true);
        return;
      }
      if (!e.target.matches('#sortSelect')) return;
      var value = e.target.value;
      if (value === 'vendor-asc') {
        vendorSort();
        var u = new URL(window.location.href);
        u.searchParams.delete('sort_by');
        history.replaceState({ arrdel: true }, '', u.toString());
        return;
      }
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', value);
      url.searchParams.delete('page');
      load(url.toString(), true);
    });

    window.addEventListener('popstate', function () {
      load(window.location.href, false);
    });
  })();

  /* ---------- PDP: gallery, variant picker, AJAX add to cart ---------- */
  (function () {
    var pdp = document.getElementById('pdpRoot');
    if (!pdp) return;

    /* gallery */
    var main = document.getElementById('pdpMain');
    pdp.querySelectorAll('.pdp__thumbs button').forEach(function (b) {
      b.addEventListener('click', function () {
        pdp.querySelectorAll('.pdp__thumbs button').forEach(function (x) { x.classList.remove('is-active'); });
        b.classList.add('is-active');
        if (main) {
          main.src = b.dataset.full;
          if (b.dataset.alt) main.alt = b.dataset.alt;
        }
      });
    });

    /* variants */
    var variantData = document.getElementById('pdpVariants');
    var variants = variantData ? JSON.parse(variantData.textContent) : [];
    var form = pdp.querySelector('form[data-product-form]');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var addBtn = document.getElementById('addToCart');
    var priceEl = document.getElementById('pdpPrice');

    function selectedOptions() {
      var opts = [];
      pdp.querySelectorAll('.sizebtns[data-option-index]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        opts[parseInt(group.dataset.optionIndex, 10)] = checked ? checked.value : null;
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return opts[i] === o; });
      });
    }

    function refresh() {
      if (!variants.length) return;
      var variant = findVariant(selectedOptions());
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (priceEl) {
        priceEl.innerHTML = variant.compare_at_price > variant.price
          ? '<s>' + formatMoney(variant.compare_at_price) + '</s>' + formatMoney(variant.price)
          : formatMoney(variant.price);
      }
      if (addBtn) {
        if (variant.available) {
          addBtn.disabled = false;
          addBtn.textContent = (addBtn.dataset.labelAdd || 'ADD TO CART') + ' — ' + formatMoney(variant.price);
        } else {
          addBtn.disabled = true;
          addBtn.textContent = addBtn.dataset.labelSoldout || 'SOLD OUT';
        }
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url.toString());
    }

    pdp.querySelectorAll('.sizebtns input[type="radio"]').forEach(function (r) {
      r.addEventListener('change', refresh);
    });

    /* AJAX add to cart with reference feedback */
    if (form && addBtn) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addBtn.disabled) return;
        var original = addBtn.textContent;
        addBtn.disabled = true;
        fetch(form.action + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: parseInt(idInput.value, 10), quantity: 1 })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return fetch('/cart.js').then(function (c) { return c.json(); });
          })
          .then(function (cart) {
            updateCartCount(cart.item_count);
            addBtn.textContent = (addBtn.dataset.labelAdded || 'ADDED TO CART') + ' ✓';
            setTimeout(function () {
              addBtn.textContent = original;
              addBtn.disabled = false;
            }, 2200);
          })
          .catch(function () {
            addBtn.disabled = false;
            form.submit(); /* fall back to native */
          });
      });
    }
  })();

  /* ---------- cart: AJAX quantity + remove with optimistic totals ---------- */
  (function () {
    var cart = document.getElementById('cartRoot');
    if (!cart) return;
    var pending = false;

    function optimistic() {
      var subtotal = 0, items = 0;
      cart.querySelectorAll('.cartline').forEach(function (line) {
        var unit = parseInt(line.dataset.price, 10); /* cents */
        var qty = parseInt(line.querySelector('.qty input').value, 10) || 0;
        subtotal += unit * qty;
        items += qty;
        var priceEl = line.querySelector('.cartline__price');
        if (priceEl) priceEl.textContent = formatMoney(unit * qty);
      });
      var sub = document.getElementById('sumSubtotal');
      var tot = document.getElementById('sumTotal');
      if (sub) sub.textContent = formatMoney(subtotal);
      if (tot) tot.textContent = formatMoney(subtotal); /* shipping complimentary */
      updateCartCount(items);
      return items;
    }

    function commit(line, quantity) {
      pending = true;
      fetch(ROUTES.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          pending = false;
          /* reconcile with server truth */
          var sub = document.getElementById('sumSubtotal');
          var tot = document.getElementById('sumTotal');
          if (sub) sub.textContent = formatMoney(data.items_subtotal_price);
          if (tot) tot.textContent = formatMoney(data.total_price);
          updateCartCount(data.item_count);
          if (data.item_count === 0) window.location.reload();
        })
        .catch(function () {
          pending = false;
          window.location.reload();
        });
    }

    cart.addEventListener('click', function (e) {
      var btn = e.target.closest('.qty button');
      if (btn) {
        var lineEl = btn.closest('.cartline');
        var input = lineEl.querySelector('.qty input');
        var v = (parseInt(input.value, 10) || 1) + (btn.dataset.dir === 'up' ? 1 : -1);
        input.value = Math.max(1, v);
        optimistic();
        commit(parseInt(lineEl.dataset.index, 10), parseInt(input.value, 10));
        return;
      }
      var rm = e.target.closest('.cartline__remove');
      if (rm) {
        e.preventDefault();
        var el = rm.closest('.cartline');
        var index = parseInt(el.dataset.index, 10);
        el.remove();
        /* re-number remaining lines: Shopify line indexes shift after removal */
        cart.querySelectorAll('.cartline').forEach(function (l, i) { l.dataset.index = i + 1; });
        var left = optimistic();
        commit(index, 0);
        if (!left) {
          /* commit() reloads once the server confirms an empty cart */
        }
      }
    });

    cart.addEventListener('change', function (e) {
      if (!e.target.matches('.qty input') || pending) return;
      var lineEl = e.target.closest('.cartline');
      e.target.value = Math.max(1, parseInt(e.target.value, 10) || 1);
      optimistic();
      commit(parseInt(lineEl.dataset.index, 10), parseInt(e.target.value, 10));
    });
  })();
})();
